module.exports = __webpack_public_path__ + "img/icon-coupon-active.bc560c53.svg";